import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
    aluminai: {
        data: [],
        loading: false,
        error: null,
    },
    news: {
        data: [],
        loading: false,
        error: null,
    },
    registration: {
        data: [],
        loading: false,
        error: null,
    },
    intake: {
        data: [],
        loading: false,
        error: null,
    },
    alumnigallery: {
        data: [],
        loading: false,
        error: null,
    },
    dirrectory: {
        data: [],
        pagination: {
            total: 0,
            page_size: 10,
            current_page: 1,
            total_pages: 1,
        },
        loading: false,
        error: null,
    },
};

export const fetchDirrectoryData = createAsyncThunk(
    "aluminai/fetchDirrectoryData",
    async ({ page, page_size }, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/AlumniPage/getAlumniDirectoryUser?page=${page}&page_size=${page_size}`
            );
            console.log("API Response:", response.data);

            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || "Something went wrong");
        }
    }
);

const aluminaiSlice = createSlice({
    name: "aluminai",
    initialState,
    reducers: {
        fetchAluminaiStart(state) {
            state.aluminai.loading = true;
            state.aluminai.error = null;
        },
        fetchAluminaiSuccess(state, action) {
            state.aluminai.loading = false;
            state.aluminai.data = action.payload;
        },
        fetchAluminaiFailure(state, action) {
            state.aluminai.loading = false;
            state.aluminai.error = action.payload;
        },
        fetchNewsStart(state) {
            state.news.loading = true;
            state.news.error = false;
        },
        fetchNewsSuccess(state, action) {
            state.news.loading = false;
            state.news.data = action.payload;
        },
        fetchNewsFailure(state, action) {
            state.news.loading = false;
            state.news.error = action.payload;
        },
        postRegistrationStart(state) {
            state.registration.loading = true;
            state.registration.error = null;
        },
        postRegistrationSuccess(state, action) {
            state.registration.loading = false;
            state.registration.data.push(action.payload);
        },
        postRegistrationFailure(state, action) {
            state.registration.loading = false;
            state.registration.error = action.payload;
        },
        fetchIntakeStart(state) {
            state.intake.loading = true;
            state.intake.error = false;
        },
        fetchIntakeSuccess(state, action) {
            state.intake.loading = false;
            state.intake.data = action.payload;
        },
        fetchIntakeFaliure(state, action) {
            state.intake.loading = false;
            state.intake.error = action.payload;
        },
        fetchGalleryStart(state) {
            state.alumnigallery.loading = true;
            state.alumnigallery.error = false;
        },
        fetchGallerySuccess(state, action) {
            state.alumnigallery.loading = false;
            state.alumnigallery.data = action.payload;
        },
        fetchGalleryFaliure(state, action) {
            state.alumnigallery.loading = false;
            state.alumnigallery.error = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchDirrectoryData.pending, (state) => {
                state.dirrectory.loading = true;
                state.dirrectory.error = null;
            })
            .addCase(fetchDirrectoryData.fulfilled, (state, action) => {
                state.dirrectory.loading = false;
                state.dirrectory.data = action.payload.data;
                state.dirrectory.pagination = action.payload.pagination;
            })
            .addCase(fetchDirrectoryData.rejected, (state, action) => {
                state.dirrectory.loading = false;
                state.dirrectory.error = action.payload;
            });
    },
});

export const {
    fetchAluminaiStart,
    fetchAluminaiSuccess,
    fetchAluminaiFailure,
    fetchNewsStart,
    fetchNewsSuccess,
    fetchNewsFailure,
    postRegistrationStart,
    postRegistrationSuccess,
    postRegistrationFailure,
    fetchIntakeStart,
    fetchIntakeSuccess,
    fetchIntakeFaliure,
    fetchGalleryStart,
    fetchGallerySuccess,
    fetchGalleryFaliure,
} = aluminaiSlice.actions;

export const fetchAlumniGalleryData = () => async (dispatch) => {
    dispatch(fetchGalleryStart());
    try {
        const response = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/AlumniPage/getAlbum`
        );
        const data = response.data.data || [];
        dispatch(fetchGallerySuccess(data));
    } catch (error) {
        console.error("Gallery fetch error:", error); // Log the full error
        let errorMessage = "Something went wrong";
        if (axios.isAxiosError(error)) {
            errorMessage = error.response?.data?.message || error.message || "Request failed"; // more info from backend
            if (error.response?.status === 404) {
                errorMessage = "No albums available"; // Override for 404
            }
        }
        dispatch(fetchGalleryFaliure(errorMessage));
    }
};

export const fetchAluminaiData = () => async (dispatch) => {
    dispatch(fetchAluminaiStart());
    try {
        const response = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/AlumniPage/getAlumni`
        );
        const data = response.data.data[0] || {};

        dispatch(
            fetchAluminaiSuccess({
                vision: data.vision || "",
                mission: data.mission || "",
                goals: data.goals || "",
            })
        );
    } catch (error) {
        dispatch(fetchAluminaiFailure(error.message || "Something went wrong"));
    }
};

export const fetchIntakes = (degreeId = null) => async (dispatch) => {
    dispatch(fetchIntakeStart());
    try {
        let url = `${process.env.REACT_APP_BACKEND_URL}/AlumniPage/getAlumniIntake`;
        if (degreeId) {
            url += `?degreeId=${degreeId}`;
        }

        const response = await axios.get(url);
        const data = response.data.data || [];
        dispatch(fetchIntakeSuccess(data));
        console.log(data);
    } catch (error) {
        dispatch(fetchIntakeFaliure(error.message || "Something went wrong"));
    }
};

export const fetchNewsData = () => async (dispatch) => {
    dispatch(fetchNewsStart());
    try {
        const response = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/AlumniPage/getAlumniNews`
        );
        const data = response.data.data || [];
        dispatch(fetchNewsSuccess(data));
    } catch (error) {
        dispatch(fetchNewsFailure(error.message || "Something went wrong"));
    }
};

export const postAlumniRegistration = (registrationData) => async (dispatch) => {
    dispatch(postRegistrationStart());
    try {
        const response = await axios.post(
            `${process.env.REACT_APP_BACKEND_URL}/AlumniPage/addAlumniRegistration`,
            registrationData
        );

        if (response.data.success) {
            dispatch(postRegistrationSuccess(response.data));
            return { success: true, message: response.data.message };
        }

        return { success: false, message: response.data.message || "Registration failed." };
    } catch (error) {
        dispatch(postRegistrationFailure(error.message || "Something went wrong"));
        return { success: false, message: error.message || "Something went wrong" };
    }
};

export default aluminaiSlice.reducer;